jQuery(document).ready(function($){
  
  var variants = [7262177919033,7083658149945];

  var check_cart = false;
  var item_in_cart = false;
  
  $.ajax({
    url: '/cart.js',
    type: 'GET',
    dataType: 'json',
    success:function(data){
     check_cart = true;
      if(data.item_count > 0){
        $.each(data.items,function(){
          if($.inArray(this.variant_id,variants) > -1){
            item_in_cart = true;

            //$('.ajax-add-to-cart').attr('href','https://cashier.boldcommerce.com/checkout/buy-body-dynamix').removeClass('ajax-add-to-cart');
            
          }
        }); 
      }
    }
  }); 
  
  
  $('.ajax-add-to-cart').click(function(e){
  	e.preventDefault();
    var url = $(this).attr('href');
    var id = $(this).attr('data-id');
    var quantity = 1;
    var btn = $(this);
    var original_txt = btn.html();
    
    btn.html('Loading...');
    
    if((check_cart && !item_in_cart) || !check_cart){
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          id: id,
          quantity: quantity
        },
        dataType:'json',
        success:function(data){
          btn.html(original_txt);
          $('#checkout_form button').click();
        }
      });
    }else{
      btn.html(original_txt);
      $('#checkout_form button').click();
    }
    
    
  });
  

});